<template>
  <div>
    <h2>Priority List</h2>
    <b-table striped  v-if="list && list.length > 0" :items="list" :fields="['Policy', 'Status']">
      <template #cell(Policy)="data">
        <h4><router-link :to="`/${data.item._link.replace('#','')}`">{{ data.value | policy('address', data.item.Reference.replace('|', ', ')) }}</router-link></h4>
        <div>{{ data.value | policy('policy') }}</div>
        <code>Risk score of {{ data.item['Risk Score'] }}</code>
      </template>
    </b-table>
    <celebrate v-if="list && list.length === 0"/>
  </div>
</template>

<script>
import Celebrate from './Celebrate.vue'

export default {
  components: { Celebrate },
  props: ['list']
}
</script>
